import { readEnv, type Env } from './config';

declare global {
  interface Window {
    /** Set by /config.js before the app starts, see public/config.js. */
    __APP_CONFIG__?: unknown;
  }
}

export type { Env };
export { readEnv };

/**
 * Settings of the stand: APP_* variables of the container without the prefix,
 * `APP_API_URL=…` → `env.API_URL`. They are read at startup, not at build time, so one image
 * serves every stand. In the dev server they come from APP_* in `.env`, empty in tests and in the
 * shell prerendered at build time.
 */
export const env: Env =
  typeof window === 'undefined' ? {} : readEnv(window.__APP_CONFIG__);
